
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"image"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.336 7.082a1.563 1.563 0 103.125 0 1.563 1.563 0 00-3.125 0zm12.499 7.048L13.19 8.668a.703.703 0 00-1.16-.013l-1.871 2.68-1.158-.931a.703.703 0 00-1.025.159L5.59 14.146","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.875 2.52a1.25 1.25 0 00-1.25 1.25v12.46a1.25 1.25 0 001.25 1.25h16.25a1.25 1.25 0 001.25-1.25v-10c0-.326-.127-.639-.355-.872l-2.402-2.463a1.25 1.25 0 00-.895-.376H1.874z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    